/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* The condition operator
*/
export enum ConditionOperatorEnum {
  And = 'And',
  Or = 'Or',
  Equals = 'Equals',
  NotEquals = 'Not Equals',
  In = 'In',
  NotIn = 'Not In',
  Contains = 'Contains',
  NotContains = 'Not Contains',
  ContainsNoneOf = 'Contains None Of',
  ContainsAnyOf = 'Contains Any Of',
  StartsWith = 'Starts With',
  NotStartsWith = 'Not Starts With',
  EndsWith = 'Ends With',
  NotEndsWith = 'Not Ends With',
  From = 'From',
  To = 'To'
}
